import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {TableHead} from "../system/thead";
import React, {useState} from "react";
import {PencilIcon} from "@heroicons/react/24/solid";


const TABLE_HEAD = ["#", "کاربر", "مباشر", "گرایش", "مبلغ کل", "سهم مشاور", "تاریخ", "زمان", "مدت", "عملیات"];

export function ConsultationPaymentGrid({
                                          consultationPayments,
                                          setModalOpen,
                                          setSelectedRow,
                                          setSortBy,
                                          sortType,
                                          setSortType
                                        }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "مباشر": "agent_name",
    "گرایش": "branch_title",
    "مبلغ کل": "price",
    "سهم مشاور": "agent_share",
    "تاریخ": "date",
    "زمان": "start_time",
    "مدت": "tel_prefix",
    "عملیات": "duration",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "مباشر": true,
    "گرایش": true,
    "مبلغ کل": true,
    "سهم مشاور": true,
    "تاریخ": true,
    "زمان": true,
    "مدت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {consultationPayments.map(
          ({
             id,
             person_name,
             person_phone,
             agent_name,
             agent_phone,
             branch_title,
             price,
             agent_share,
             date,
             start_time,
             end_time,
             duration
           }, index) => {
            const isLast = index === consultationPayments.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {person_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(person_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {agent_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(agent_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(price, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(agent_share, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(date)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(`${start_time} - ${end_time}`)}
                    </Typography>
                  </div>
                </td>


                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(duration)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setSelectedRow(consultationPayments[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}